export const decodeValue = (encoded: string | undefined): string | undefined => {
    try {
        if (!encoded) return undefined;
        return decodeURIComponent(atob(encoded));
    } catch (error) {
        console.error("Decoding failed for:", encoded, error);
        return undefined;
    }
};

export const encodeValue = (value: string) => btoa(encodeURIComponent(value));